import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStateService } from '../services/auth/auth-state.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('assets')) {
    return next(req);
  }

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const authState = inject(AuthStateService);
  const authHeader = authState.getAuthorizationHeader();

  // No token yet — forward with credentials only so the top-nav's portal cookie
  // requests work. Backend API calls without a token will return 401 and the
  // global error handler will redirect to portal login.
  if (authHeader === undefined) {
    return next(req.clone({ withCredentials: true }));
  }

  return next(
    req.clone({
      withCredentials: true,
      setHeaders: { Authorization: authHeader },
    }),
  );
};
